module.exports = __webpack_public_path__ + "static/media/logo.913b781d.png";